import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    checkboxAnatomy.keys,
)

const baseStyle = definePartsStyle({
    label: {},
    control: {
        borderWidth: '1px',
    },
})

const sizes = {
    md: definePartsStyle({
        control: defineStyle({
            boxSize: '18px',
        }),
        label: defineStyle({
            fontSize: '0.6875rem',
            marginLeft: '6px',
        }),
    }),
}

const variants = {
    primary: definePartsStyle(({ theme }) => {
        const { captions, green, bg, stroke } = theme.colors

        return {
            control: defineStyle({
                rounded: '3px',
                borderColor: captions.light,
                _hover: {
                    borderColor: green.default,
                },
                _focus: {
                    borderColor: green.default,
                },
                _checked: {
                    bgColor: bg.neon10,
                    borderColor: bg.neon10,
                    color: green.default,
                    _hover: {
                        bgColor: bg.neon10,
                        borderColor: green.default,
                    },
                    _focus: {
                        borderColor: green.default,
                    },
                    _disabled: {
                        bgColor: bg.neon10,
                    },
                },
                _disabled: {
                    borderColor: stroke.light,
                    bgColor: 'transparent',
                },
            }),
        }
    }),
    xero: definePartsStyle(({ theme }) => {
        const { captions, green, bg, stroke, dark } = theme.colors

        return {
            control: defineStyle({
                rounded: '26px',
                borderColor: captions.light,
                _hover: {
                    borderColor: green.default,
                },
                _focus: {
                    borderColor: green.default,
                },
                _checked: {
                    bgColor: bg.neon10,
                    borderColor: bg.neon10,
                    color: green.default,
                    _hover: {
                        bgColor: bg.neon10,
                        borderColor: green.default,
                    },
                    _focus: {
                        borderColor: green.default,
                    },
                    _disabled: {
                        bgColor: bg.neon10,
                    },
                },
                _disabled: {
                    borderColor: stroke.light,
                    bgColor: 'transparent',
                },
            }),
            label: {
                fontSize: '0.75rem',
                lineHeight: '1.25rem',
                color: green.default,
            },
        }
    }),
    radio: definePartsStyle(({ theme }) => {
        const { green, bg, stroke } = theme.colors

        return {
            control: defineStyle({
                rounded: '26px',
                borderColor: bg.neon10,
                _hover: {
                    borderColor: bg.neon10,
                },
                _focus: {
                    borderColor: bg.neon10,
                },
                _checked: {
                    bgColor: bg.neon10,
                    borderColor: bg.neon10,
                    color: green.default,
                    _hover: {
                        bgColor: bg.neon10,
                        borderColor: bg.neon10,
                    },
                    _focus: {
                        borderColor: bg.neon10,
                    },
                    _disabled: {
                        bgColor: bg.neon10,
                    },
                },
                _disabled: {
                    borderColor: stroke.light,
                    bgColor: 'transparent',
                },
            }),
            label: {
                fontSize: '0.75rem',
                lineHeight: '1.25rem',
                color: green.default,
            },
        }
    }),
}

export const Checkbox = defineMultiStyleConfig({
    baseStyle,
    sizes,
    variants,
    defaultProps: {
        variant: 'primary',
    },
})
